type ISubRoutingURLs = {
  [key: string]: string;
}

export const SubRoutingURLs: ISubRoutingURLs = {
  // Devitee Service
  POOJA_BOOKING_REQUEST: "Pooja Booking Request",
  REFUND: "Refund",
  POOJA_BOOKING: "Pooja Booking",
  HALL_RENTAL : "Hall Rental",
  DONATION: "Donation",
  MATCHING_DONATIONS: "Matching Donations",
  DONOR_ADVISORY_FUNDS: "Donor Advisory Funds",
  VASTRA: "Vastra",
  LADDU_OR_KARASEV_OR_VADA: "Laddu or Karasev or Vada",
  EVENT_HALL_BOOKING_REQUEST: "Event Hall Booking Request",
  MODIFY_PROFILE: "Modify Profile",
  DEVOTEE_POOJA_AND_HALL_REQUESTS: "Devotee Pooja & Hall Requests",
  MODIFY_DEVOTEE_PROFILE: "Modify Devotee Profile",
  devoteePoojaRequest: "Devotee Pooja Request",
  eventHallContractForm: "Event Hall Contract Form Request", // not implemented as of now
  categories: "Categories", // not needed
  calendar: "Calendar", // not needed
  // Devotee Management
  REGISTER_DEVOTEE: "Register Devotee",
  DUPLICATE_DEVOTEE_RECORDS: "Duplicate Devotee Records",
  CONSOLIDATE_ACCOUNTS: "Consolidate Accounts",
  RESTORE_CONSOLIDATE_ACCOUNTS: "Restore Consolidate Accounts",
  DELETED_DEVOTEE_LIST: "Deleted Devotee List",
  QUICK_REGISTRATION: "Quick Registration",
  unSubscribe: "Unsubscribe",
  // Reports
  DEVOTEE_REPORT: "Devotee Report",
  DONATION_REPORT: "Donation Report",
  SPECIAL_EVENT_DONATION_REPORT: "Special Event Donation Report",
  PRIESTS_SCHEDULE_SUMMARY_CONSOLIDATED: "Priest's Schedule Summary - Consolidated"
}

export const RoutingURLs = {
  home: "/",
  dashboard: "/dashboard",
  donations: "/donations",
  register: "/register",
  user: "/user",
  changePassword: "/changepassword",
  meetingMinutes: "/meetingminutes",
  devoteeRegister: "/devoteeregister",
  login: "/login",
  managementTeam: "/mteam",
  infoPoojaItems: "/Information/poojaItems",
  awards: "/awards",
  contactInfo: "/contactinfo",
  poojaItems: "/poojaitems",
  serviceInformation: "/serviceinformation",
  religious: "/religious",
  human: "/human",
  youthAndEducation: "/youthandeducation",
  feedback: "/feedback",
  refundPolicy: "/refundPolicy",
  eventFacilities: "/eventFacilities",
  overview: "/overview",
  newsletter: "/newsletter",
  cultural: "/cultural",
  calendar: "/Calendar",
  bhajana: "/bhajana",
  faqs: "/faqs",
  creditPayment: "/creditPayment",
  check: "/check",
  aboutTemple: "/abouttemple",
  volunteer: "/volunteer",
  priests: "/priests",
  humanServices: "/humanservices",
  servicesYouthAndEducation: "/servicesyouthandeducation",
  goldenAgers: "/goldenAgers",
  educational: "/educational",
  spirtual: "/spirtual",
  health: "/health",
  funeral: "/funeral",
  retirement: "/retirement",
  inHouse: "/inhouse",
  youngAdults: "/youngadults",
  humanServicesFaqs: "/humanservicesfaqs",
  receipt: "/receipt",
  timeslots: "/timeslots",
  hallForm: "/hallForm",
  priestScheduling: "/priest-scheduling"
}